import { BaseRequest } from "../../models";
import * as Immutable from "immutable"
import { BaseEntity } from "../../baseEntity";

export class ContactRequest extends BaseRequest {

  confSessionId: number;
  configurationId: number;
  name: string;
  email: string;
  company: string;
  city: string;
  contactByPhone: boolean;
  phoneNumber: string;
  message: string;

}